// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"Badge_badgeContainer__2UlG0","info":"Badge_info__Y4QQ5","badgeLabel":"Badge_badgeLabel__I_80o","warning":"Badge_warning__7FYIc"};